import { HttpClient } from '@angular/common/http';
import { DestroyRef, Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IndividuSimpleModel, LiaisonPersonFormateur } from 'src/app/models/individus/individu-simple.model';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root',
})
export class IndividusService {
  private readonly baseUrlApi = this.configService.config.urlApi;;
  private destroyRef = Inject(DestroyRef);
  private get individusUrl() {
    return `${this.baseUrlApi}/api/crm/individus`;
  }

  constructor(private client: HttpClient, private configService: ConfigService) {}

  public getNewGuid(): Observable<string> {
    return this.client.get<string>(`${this.individusUrl}/getIndividuGuid/`);
  }

  public getIndividuSimpleFromGuid(guid: string): Observable<IndividuSimpleModel> {
    return this.client.get<IndividuSimpleModel>(`${this.individusUrl}/GetIndividuSimpleByGuid/${guid}`);
  }

  public lierPersonEtFormateur(body: LiaisonPersonFormateur): Observable<LiaisonPersonFormateur>{
    return this.client.put<LiaisonPersonFormateur>(`${this.baseUrlApi}/api/crm/LiaisonPersonneFormateur/AddPersonneFormateur`, body)
  }

  public delierPersonEtFormateur(body: LiaisonPersonFormateur): Observable<LiaisonPersonFormateur>{
    return this.client.put<LiaisonPersonFormateur>(`${this.baseUrlApi}/api/crm/LiaisonPersonneFormateur/DeletePersonneFormateur`, body)
  }

  public getCreateurModificateur(id: number|string): Observable<any>{
    return this.client.get(`${this.configService.config.urlApi}/api/crm/Individus/GetIndividuNomPrenom/NomPrenom/${id}`)
  }

  public getName(guid: number | string): Observable<string> {
    return this.getCreateurModificateur(guid).pipe(
      map((res) =>  `${res.nom ?? ''} ${res.prenom ?? ''}`.trim())
    );
  }
}
